import { useEffect } from 'react';
import PersonaEntregaForm from '../../components/personal-entrega/PersonaEntregaForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  usePersonalEntregaStore,
  type RegistrarPersonaEntrega
} from '../../stores/personal-entrega/personal-entrega.store';

const AgregarPersonaEntrega = () => {
  const { current: persona, nuevo, registrar } = usePersonalEntregaStore();

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore();
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore();

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = (values: RegistrarPersonaEntrega) => {
    return registrar(values);
  };

  return (
    <PersonaEntregaForm
      esAgregar={true}
      persona={persona}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default AgregarPersonaEntrega;
